import { getError } from "@/utils/helpers";
import allScanService from "@/services/Scan/allScanService";

export const namespaced = true;

export const state = {
  allScan: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_ALLSCAN(state, allScan) {
    state.allScan = allScan;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getScan({ commit }, UserId) {
    commit("SET_LOADING", true);

    allScanService
      .getAllScan(UserId)
      .then((response) => {
        commit("SET_ALLSCAN", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  allScan: (state) => {
    return state.allScan;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
